
<template>
	<div class="m_question">
        <div class="issueName" >
          <span>{{question.title}}</span>
          <span class="icon-top" @click="isshow"></span>
        </div>
        <div class="issuespan" v-if="isopen" >
		    <span>{{question.content}}</span>
        </div>
      </div>
</template>
<script>
	export default{
		name:'questionitem',
		props:['question'],
		data(){
			return {
				isopen:false
			}
		},
		methods:{
			isshow(){
				this.isopen=!this.isopen;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/userCenter/questionitem.vue